import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";

import facebook from "../../images/facebook.png"
import twitter from "../../images/twitter.png"

const Wrapper = styled.div`
padding-top:25px;
padding-bottom:25px;
`
const Cells = styled.div`
display:flex;
justify-content:space-between;
`
const Cell1 = styled.div`
@media (max-width: 599px) {
  font-size: 13px;
  padding-top:7px;
} ;
`
const Cell2 = styled.div`
`
const index = () => {
  return (
    <div>
      <Wrapper>
        <Container maxWidth="xl">
          <Cells>
            <Cell1>© 2022 Paramountvault.com</Cell1>
            <Cell2>
              <img className="img-fluid " src={facebook} />{" "}
              <img className="img-fluid ml-2 mr-sm-5" src={twitter} />
            </Cell2>
          </Cells>
        </Container>
      </Wrapper>
    </div>
  );
};

export default index;
